export default "__VITE_ASSET__BfNrYxn0__"